import * as Utils from "../utils";

export const schema = [
  {
    id: "/Types/Param/Type/Checkbox",
    type: "object",
    properties: {
      ...Utils.properties,
      default: { label: "Default value", type: "boolean", default: false },
    },
    required: [],
  },
];
